import "./FourPointInspectionSouthFlorida.module.css";
import Header from "@/reusable_sections/Header";
import StructuralDamageAfterStormOrHurricane from "./sections/StructuralDamageAfterStormOrHurricane";
import WhatIsA4PointInspection from "./sections/WhatIsA4PointInspection";
import WhenIsA4PointInspectionNeeded from "./sections/WhenIsA4PointInspectionNeeded";
import InstallationRepairReplacementOptions from "./sections/InstallationRepairReplacementOptions";
import SignsYouNeedWaterHeaterReplacement from "./sections/SignsYouNeedWaterHeaterReplacement";
import FourPointVsWindMitigationInspection from "./sections/FourPointVsWindMitigationInspection";
import WhyChooseUsForSelling from "./sections/WhyChooseUsForSelling";
import ServiceAreas from "./sections/ServiceAreas";
import FrequentlyAskedQuestions from "./sections/FrequentlyAskedQuestions";
import HomeInsuranceCta from "./sections/HomeInsuranceCta";
import CallToAction from "./sections/CallToAction";
import Footer from "@/reusable_sections/Footer";
export default function FourPointInspectionSouthFloridaPage() {
  return <div>
      <Header />
      <StructuralDamageAfterStormOrHurricane />
      <WhatIsA4PointInspection />
      <WhenIsA4PointInspectionNeeded />
      <InstallationRepairReplacementOptions />
      <SignsYouNeedWaterHeaterReplacement />
      <FourPointVsWindMitigationInspection />
      <WhyChooseUsForSelling />
      <ServiceAreas />
      <FrequentlyAskedQuestions />
      <HomeInsuranceCta />
      <CallToAction />
      <Footer />
    </div>;
}